<template>
	<el-dialog title="修改预约申请" width="400px" :visible.sync="dialogVisible" :show-close="true"
		:close-on-click-modal="false" :close-on-press-escape="false">
		<div class="update-approve" v-loading="loading">
			<!--<div v-if="showCount">
				<p>当前时间段已预约数量：{{// appointedCount}}</p>
				<p>当前时间段已申请修改数量：{{unApproveCount}}</p>
			</div>-->
			<div>
				<p>修改说明</p>
				<p>{{approveProcess.eventContent}}</p>
			</div>
			<div>
				<p>修改时间</p>
				<p>{{appointDate}}</p>
			</div>
			<div>
				<p>是否同意</p>
				<p>
					<el-radio-group v-model="formData.approveStatus" class="sex">
						<el-radio :label="2">同意</el-radio>
						<el-radio :label="3">拒绝</el-radio>
					</el-radio-group>
					<el-input type="textarea" style="" :autosize="{ minRows: 4, maxRows: 5}"
						v-model="formData.approveNote" placeholder="请输入拒绝的理由"></el-input>
				</p>
			</div>
			<div>
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button @click="submit()">提交</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
  import base from '@/api/common';
  import {getAxios, putAxios} from "@/api/http";
  import timezone from "@/api/timezone";

  export default {
    name: "update-approve",
    data() {
      return {
        approveProcess: {},
        dialogVisible: false,
        appointDate: '',
        formData: {
          approveStatus: 2,
          approveNote: ''
        },
        loading: false,
        // appointedCount: 0,
        unApproveCount: 0,
        // showCount: false,
      }
    },
    methods: {
      submit() {
        let vm = this;
        vm.loading = true;
        if (vm.formData.approveStatus == 3 && $.trim(vm.formData.approveNote).length == 0) {
          vm.$message.warning('请输入拒绝理由');
          vm.loading = false;
          return;
        }
        let params = {
          id: vm.approveProcess.id,
          appointId: vm.approveProcess.eventId,
          approveStatus: vm.formData.approveStatus,
          approveNote: vm.formData.approveNote
        }
        putAxios(base.api.approveProcess.appointUpdate, params)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message.success({
                message: '提交成功', onClose: _ => {
                  vm.dialogVisible = false;
                  vm.$parent.reload();
                }
              })

            } else {
              vm.$message.error(res.data.message);
            }
          }).catch((err) => {
          console.error(err);
          vm.$message.error('操作失败');
        })
      },
      getData(id) {
        let vm = this;
        getAxios(base.api.approveProcess.getByAppointId.replace("{id}", id))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.dialogVisible = true;
              // if (res.data.data.appointedCount != null && res.data.data.upApproveCount != null) {
              //   vm.showCount = true;
              //   vm.appointedCount = res.data.data.appointedCount;
              //   vm.unApproveCount = res.data.data.unApproveCount - 1 >= 0 ? res.data.data.unApproveCount - 1 : 0;
              // }
              vm.approveProcess = res.data.data.approveProcess;
              if (res.data.data.event && res.data.data.event.remark) {
                let obj = JSON.parse(res.data.data.event.remark);

                // let start = new Date(new Date().setHours(obj.timeSlot)).Format('HH:00');
                // let end = new Date(new Date().setHours(obj.timeSlot)).Format('-HH:59');
                // vm.appointDate = new Date(obj.appointDate).Format("yyyy年MM月dd日 ") + start + end;

                // vm.appointDate = timezone.bj2LocalyyyyMMddHHmmss(obj.appointDate, obj.timeSlot);
                vm.appointDate = base.utils.buildShowDate(obj.appointStartLongtime, obj.appointEndLongtime);
              }
            } else {
              vm.$parent.$message.warning(res.data.message);
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>
